<template>
    <div v-if="isInOutsideH5()" class="nav-header-container">
        <div class="header">
            <div class="header-content">
                <div class="title">{{ $store.state.app.navTitle || $route.meta.title }}</div>
                <img v-if="$route.meta.isProgress || $route.meta.showClose" src="./images/close.png" class="close" @click="onClose" />
                <div v-else class="header-right">
                    <van-popover
                        v-if="isLogin"
                        v-model="showPopover"
                        trigger="click"
                        placement="bottom-end"
                        class="nav-header-mine-menu"
                        :offset="[14, 12]"
                        :actions="actions"
                        @select="onSelectMenu"
                    >
                        <template #reference>
                            <img src="./images/avatar.png" class="avatar" />
                        </template>
                    </van-popover>

                    <img v-else src="./images/avatar.png" class="avatar" @click="login" />

                    <img src="./images/menu.png" class="menu" @click="showNavMenu = true" />
                </div>
            </div>
        </div>

        <div id="nav-header-popup-container"></div>

        <!-- 导航菜单 -->
        <NavMenu v-model="showNavMenu"></NavMenu>

        <!-- 退出登录 -->
        <Logout :show.sync="showLogout" />
    </div>
</template>

<script>
import { Popover } from 'vant'
import phoneImage from './images/phone.png'
import emailImage from './images/email.png'
import tradePasswordImage from './images/tradePassword.png'
import logoutImage from './images/logout.png'
import Logout from './components/Logout.vue'
import NavMenu from './components/NavMenu.vue'
import { isInOutsideH5, isDeviceMobile } from '@fs/utils'
import { i18n } from './i18n/index'
import { mapState } from 'vuex'
import { isLogin, login } from './utils'

const mineMenu = [
    {
        icon: phoneImage,
        key: 'phone',
        link: '/pages/changePhone.html#/',
    },
    {
        icon: emailImage,
        key: 'email',
        // link: '/pages/changeEmail.html#/',
    },
    {
        icon: tradePasswordImage,
        key: 'transPwd',
        link: '/pages/changeTradePassword.html#/verify',
    },
    {
        icon: logoutImage,
        key: 'logout',
        link: 'logout',
    },
]

export default {
    components: {
        [Popover.name]: Popover,
        Logout,
        NavMenu,
    },
    props: {
        navTitlte: {
            type: String,
            default: '',
        },
        lang: {
            type: String,
            default: 'zh-tc',
        },
    },
    data() {
        return {
            i18n,
            isLogin,
            showPopover: false,
            showLogout: false,
            showNavMenu: false,
        }
    },
    computed: {
        ...mapState('user', ['userInfo']),
        actions() {
            return mineMenu.map(el => ({
                ...el,
                text: i18n.t(el.key),
                className: 'nav-header-mine-menu-item',
            }))
        },
    },
    watch: {
        '$route.path': {
            handler() {
                this.$store.commit('app/updateNavTitle', '')
            },
        },
    },
    mounted() {
        this.initPcClick()
    },
    methods: {
        isInOutsideH5,
        login,
        initPcClick() {
            // van-popover在PC端无法自动关闭
            if (!isDeviceMobile()) {
                const onClick = e => {
                    if (!e.target.closest('.van-popover__wrapper')) {
                        this.showPopover = false
                    }
                }
                document.addEventListener('click', onClick)
                this.$once('hook:beforeDestroy', () => {
                    document.removeEventListener('click', onClick)
                })
            }
        },
        onSelectMenu(action) {
            this.showPopover = false
            const { key } = action
            let link = action.link

            if (key === 'logout') {
                this.showLogout = true
                return
            }

            if (key === 'email') {
                const linkName = this.userInfo?.email ? 'changeEmail' : 'bindEmail'
                link = `/pages/${linkName}.html#/`
            }

            if (link) {
                location.href = `${location.origin}${link}`
            }
        },

        onClose() {
            if (this.$route.meta.isProgress) {
                this.quitProgress()
            } else {
                const { closeCallback = () => history.back(), showCloseConfirm } = this.$route.meta

                if (showCloseConfirm) {
                    this.quitProgress(closeCallback)
                } else {
                    closeCallback()
                }
            }
        },

        quitProgress(callback) {
            const defaultCallback = () => {
                const isFunction = typeof this.$route.meta?.progressReturnUrl === 'function'

                if (isFunction) {
                    location.href = this.$route.meta?.progressReturnUrl()
                } else if (this.$route.meta?.progressReturnUrl) {
                    location.href = this.$route.meta?.progressReturnUrl
                }
            }

            const confirmCallback = callback || defaultCallback

            this.$dialog
                .confirm({
                    message: this.i18n.t('noSaveRecord'),
                    messageAlign: 'center',
                    confirmButtonText: this.i18n.t('confirm'),
                    overlayClass: 'nav-progress-dialog',
                })
                .then(() => {
                    confirmCallback()
                })
        },
    },
}
</script>

<style lang="less">
@import './styles/index.less';

.nav-progress-dialog + .van-dialog {
    .van-dialog-style();
}

.nav-header-mine-menu-item {
    height: 44px !important;
    font-size: 14px;
    line-height: 44px;

    .van-popover__action-icon {
        font-size: 16px;
    }

    .van-popover__action-text {
        &::after {
            border-bottom-width: 0;
        }
    }

    &:nth-last-child(1) {
        border-top: 1px solid #efefef;
    }
}
</style>
<style scoped lang="less">
.nav-header-container {
    height: 44px;
    width: calc(100% + 32px);
    margin-left: -16px;
}

.header {
    position: fixed;
    top: 0;
    left: 50%;
    z-index: 1500;
    max-width: 5.4rem;
    width: 100%;
    transform: translate(-50%, 0);
}

#nav-header-popup-container {
    position: relative;
    z-index: 4000;
}

.header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 5.4rem;
    height: 44px;
    margin: 0 auto;
    padding: 0 16px;
    background: white;

    .title {
        overflow: hidden;
        font-weight: 600;
        font-size: 18px;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .avatar {
        width: 26px;
        height: 26px;
    }

    .menu {
        width: 24px;
        height: 24px;
        margin-left: 16px;
    }

    .close {
        width: 24px;
    }

    .header-right {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        margin-left: 32px;
    }
}
</style>
